export default __webpack_public_path__ + "static/IBMPlexSans-Bold-Latin2-3c7732ea7338e0c242778980d29e9e50.woff2";